export class MandateModel {

    uid: string; 
    mandateRef: string;
    domiciliationRef: string;
    creditorName: string;
    creditorAddress: string;
    creditorPostalCode: string;
    creditorLocation: string;
    creditorState: string;
    creditorCountry: string;
    debtorName: string;
    debtorAddress: string;
    debtorPostalCode: string;
    debtorLocation: string;
    debtorState: string;
    debtorCountry: string;
    debtorBic: string;
    debtorIban: string;
    typePay: string;
    createDate: Date;
    isSigned: boolean;

    constructor() { 

    }
}